import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../common/css/plugin/datepicker.css';
import moment from 'moment';

// 시간선택이 필요없는 달력시 useTimeSelect를
// false로 보내줘야 css와 시간 선택창이 뜨지않음
// groupReservaion에 CustomDatePicker 검색후 보면
// useTimeSelect false로 넘겨주고있음
// 다른 필요할시에는 기존이랑 동일하게 진행

const CustomDatePicker = ({ selectedDate, onChange, useTimeSelect = true, minDate }) => {    
    const handleChange = (selectedDate) => {
        if (!selectedDate) return;
        if (onChange) onChange(new Date(selectedDate));
    };

    const handleRawChange = (e) => {
        const rawValue = e.target.value;

        if (/^\d{8}$/.test(rawValue)) {
            const formatted = moment(rawValue, 'YYYYMMDD');

            if (formatted.isValid() && formatted > new Date()) {
                handleChange(formatted.toDate()); 
            }
        }
    };

    return (
        <DatePicker
            selected={selectedDate}
            onChange={handleChange}
            onChangeRaw={handleRawChange}
            showTimeSelect={useTimeSelect}
            timeIntervals={30}
            placeholderText='날짜를 선택하세요'
            timeFormat='HH:mm'
            dateFormat={useTimeSelect ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd'}
            className='custom-datepicker'
            calendarClassName={
                useTimeSelect
                    ? 'custom-datepicker-calendar'
                    : 'custom-datepicker-calendar custom-datepicker-no-time react-datepicker-no-time__navigation--next'
            }
            minDate={minDate ? new Date(minDate): new Date()}
            fixedHeight
        />
    );
};

export default CustomDatePicker;
